import React from 'react';
import { useAuth } from '../features/auth/AuthContext';

export default function LockedPage() {
    const { logout } = useAuth();

    return (
        <div className="min-h-[70vh] flex items-center justify-center p-6">
            <div className="max-w-md w-full border rounded-lg bg-white shadow-sm p-6 space-y-3">
                <h1 className="text-lg font-bold text-gray-900">계정이 잠겼습니다</h1>
                <p className="text-sm text-gray-600">
                    관리자에 의해 계정이 잠금(LOCKED) 처리되어 서비스를 사용할 수 없습니다. 잠금 해제 후 다시 시도해
                    주세요.
                </p>
                <div className="pt-2 flex items-center justify-end gap-2">
                    <button
                        className="text-sm px-3 py-1.5 rounded border hover:bg-gray-50"
                        onClick={() => window.location.reload()}
                    >
                        새로고침
                    </button>
                    <button
                        className="text-sm px-3 py-1.5 rounded bg-gray-900 text-white hover:opacity-90"
                        onClick={() => {
                            logout();
                            window.location.href = '/login?logged_out=1';
                        }}
                    >
                        로그아웃
                    </button>
                </div>
            </div>
        </div>
    );
}
